module.exports = __webpack_public_path__ + "img/22.3e63e6aa.jpg";